module.exports = __webpack_public_path__ + "img/mongodb.0fbd04cb.png";